function animateFavicon(faviconImages, interval = 700) {
    let imageCounter = 0;
    setInterval(() => {
        // Remove current
        document.querySelectorAll("link[rel='icon'], link[rel='shortcut icon']").forEach(el => el.remove());
        // Add new
        const faviconHtml = `<link rel="icon" sizes="any" type="image/svg+xml" href="${faviconImages[imageCounter]}">`;
        document.querySelector('head')?.insertAdjacentHTML('beforeend', faviconHtml);
        // Cycle to next
        imageCounter = (imageCounter + 1) % faviconImages.length;
    }, interval);
}
export default () => {
    const faviconImages = [
        '/assets/dist/img/Favicon/svg/favicon-a-01.svg',
        '/assets/dist/img/Favicon/svg/favicon-b-02.svg',
        '/assets/dist/img/Favicon/svg/favicon-c-07.svg',
        '/assets/dist/img/Favicon/svg/favicon-a-05.svg',
        '/assets/dist/img/Favicon/svg/favicon-b-04.svg',
        '/assets/dist/img/Favicon/svg/favicon-c-02.svg',
        '/assets/dist/img/Favicon/svg/favicon-a-02.svg',
        '/assets/dist/img/Favicon/svg/favicon-b-07.svg',
        '/assets/dist/img/Favicon/svg/favicon-c-04.svg',
        '/assets/dist/img/Favicon/svg/favicon-a-03.svg',
        '/assets/dist/img/Favicon/svg/favicon-b-06.svg',
        '/assets/dist/img/Favicon/svg/favicon-c-01.svg',
        '/assets/dist/img/Favicon/svg/favicon-a-04.svg',
        '/assets/dist/img/Favicon/svg/favicon-b-05.svg',
        '/assets/dist/img/Favicon/svg/favicon-c-03.svg',
        '/assets/dist/img/Favicon/svg/favicon-a-06.svg',
        '/assets/dist/img/Favicon/svg/favicon-b-03.svg',
        '/assets/dist/img/Favicon/svg/favicon-c-05.svg',
        '/assets/dist/img/Favicon/svg/favicon-a-07.svg',
        '/assets/dist/img/Favicon/svg/favicon-b-01.svg',
        '/assets/dist/img/Favicon/svg/favicon-c-06.svg',
    ];
    animateFavicon(faviconImages);
};
